import type { FeatureRequestViewModel } from "@lumora/core";
import { FeatureRequestPage } from "@lumora/ui";
import { Link } from "react-router-dom";

/** Owner utility sheet for GitHub-tracked product requests (#286). */
export function OwnerFeatureRequestPage({ viewModel }: { viewModel: FeatureRequestViewModel }) {
  return (
    <div className="site-portal-sheet site-feature-request">
      <p className="site-signin-kicker">Owner portal</p>
      <h1>Request a feature</h1>
      <p className="portal-lead">
        Filed as a tracked GitHub issue. For bugs or account help use{" "}
        <Link to="/dashboard">support tickets</Link> on your dashboard.
      </p>
      <FeatureRequestPage viewModel={viewModel} title="" className="portal-feature-embed" />
    </div>
  );
}
